import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DescriptionTextService {
    private isExpanded$$ = new BehaviorSubject<boolean>(false);
    private hasDescriptionText$$ = new BehaviorSubject<boolean>(false);

    get isExpanded$(): Observable<boolean> {
        return this.isExpanded$$.asObservable();
    }

    get hasDescriptionText$(): Observable<boolean> {
        return this.hasDescriptionText$$.asObservable();
    }

    toggleExpanded(): void {
        this.isExpanded$$.next(!this.isExpanded$$.value);
    }

    setHasDescriptionText(hasDescriptionText: boolean): void {
        this.hasDescriptionText$$.next(hasDescriptionText);
    }
}
